<template>
<div class="pswp" ref="page">
    <div class="pswp__top-bar">
        <div class="number"> {{swiperIndex}}/{{imglist.length}} </div>
        <button class="icon_close" name="close">
            <span class="swiperTip" @click="closeevent">{{$t("message.Close") }}</span>
            <i class="icon-close" @click="closeevent" aria-hidden="true"></i>
        </button>
        
    </div>
    <div class="pswp__bg"></div>
    <div class="height100" >
        <swiper class="swiperDefault height100" :options="swiperOption" v-if="showSwiper" ref="honorSwiper">
            <swiper-slide class="swiper-slide" v-for="(item,index) in imglist">
                <div class="slide-img">
                    <img :alt="getObject(item.langMap,lang).altText" v-bind:src="getObject(item.langMap,lang).url" />
                </div>
                <div class="slide-caption" :class="{'animateShow':readMore}">
                    <div class="caption-content">
                        <p :class="{'img-caption':!readMore&&getObject(item.langMap,lang).showRead}">{{getObject(item.langMap,lang).caption}}</p>
                        <div 
                            class="readMore" 
                            v-if="getObject(item.langMap,lang).showRead"
                            @click="readMore=!readMore"
                        >
                            <button v-if="!readMore">{{$t("message.Read More") }}</button>
                            <button v-else>{{$t("message.Show Less") }}</button>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination" v-show="imglist.length>1">
        </div>
    </div>
</div>
</template>
<script>

export default {
    data() {
        return {
            totalRows: 0,
            jobFunctions: [],
            showSwiper:false,
            swiperOption: {
                on:{
                  transitionEnd: this.transitionEnd,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                }
            },
            swiperIndex:1,
            windowHight:500,
            readMore:false,
        }
    },
    computed:{
        innerwidth(){
          return this.$store.state.innerWidth;
        },
        __swiper__() {
            return this.$refs.honorSwiper.swiper
        }
    },
    watch:{
        innerwidth (news,old) {
            this.showSwiper = false;
            this.setWidth()
        },
     },
    props: {"imglist":null,"lang":"","closeevent":null},
    methods: {
        init:function(){
        },
        transitionEnd:function(){
            this.$set(this, "swiperIndex", this.__swiper__.activeIndex+1);
        },
        getObject(object,langCode){
            
            return !object||object.length==0?{}:object.find(o=>o.langCode==langCode);
        },
        setWidth:function(){
            var that = this;
            this.showSwiper = false;
            this.$nextTick(() => {
                this.showSwiper = true
            });
        }
    },
    mounted() {
        var that = this;
        this.swiperOption = {
                on:{
                  transitionEnd: this.transitionEnd,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + '<span class="swiperTip">' + that.$i18n.t("message.gotoPage1") + (index + 1) + that.$i18n.t("message.gotoPage2") + '</span></span>';
                    },
                }
            }
        var mySwiper;
        setTimeout(function(){
            that.setWidth()
        },200)
        var _this = this;
    }
}
</script>